import { render, staticRenderFns } from "./Ahorcado.vue?vue&type=template&id=2f65084a&scoped=true"
import script from "./Ahorcado.vue?vue&type=script&lang=js"
export * from "./Ahorcado.vue?vue&type=script&lang=js"
import style0 from "./Ahorcado.vue?vue&type=style&index=0&id=2f65084a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65084a",
  null
  
)

export default component.exports